/**
 * Created by ganlu on 24/11/2016.
 */
class MediaAccountService {
    constructor($http, AppConfig, message) {
        "ngInject";

        this.mediaAccounts = {
            'weixin': null,
            'weibo': null,
            'toutiao': null
        };

        this.mediaNames = [
            '',
            'weixin',
            'weibo',
            'toutiao'
        ];

        this.$http = $http;
        this.AppConfig = AppConfig;
        this.message = message;
    }

    init(callback) {
        this.$http
            .get(this.AppConfig.server_url + '/media/list', {
                withCredentials: true
            }).then(
            (response) => {
                // response.data=[{"id":13,"user_id":12,"account_type":1,"account_id":"wxa64ce89c222e2188","name":"\u54ce\u5440\u539f\u6765\u4f60\u4e5f\u5728\u8fd9\u91cc","params":{"user_name":"gh_bc1c63b9f4a6","alias":"aiyaaaaaaaaaaaaaa","qrcode":"http:\/\/mmbiz.qpic.cn\/mmbiz_jpg\/ibTB0aD5VsBx2KiaOPygbAtvraCr6tQUwhzUppN85El9ckCtDU5jjMTMqlJSvQnBHhqK7pwDz10CoA6keiawCyMdg\/0","head_img":""},"created_at":1503040204,"access_token":"bg4Lj6xmvIWkUDvFJOLdLukB8NCFMemHRtryjQNCn_N5U_8FaQoT2FFgJxxe8EhGiXcU81_x2V5HKUCO3SkZR94jqFDnvXhKVsJLx6IFgl9BaRObq88Yqk88_RpzdlQnJLQaAHDBDI"},{"id":14,"user_id":12,"account_type":3,"account_id":"50022088629","name":"\u624b\u673a\u7528\u623750022088629","params":null,"created_at":null,"access_token":"7b7e3650d2e9721bea3da9be2eb42a310014"}]
                response.data.forEach((m) => {
                    let mediaName = this.mediaNames[m.account_type];
                    this.mediaAccounts[mediaName] = m;
                });

                if (typeof(callback) == 'function') {
                    callback();
                }
            },
            (response) => {
                this.message.error(response.data);
            }
        );
    }
}

export default MediaAccountService;



// WEBPACK FOOTER //
// ./src/app/modules/media-account/media-account.service.js